<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 5V2H18V5L12 10V16L8 18V10L2 5Z" />
</svg>
